var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28949 14.0412L4.0662 16.3441C3.70048 16.5435 3.26557 16.2345 3.33353 15.8236L4.14475 10.9179L0.69181 7.42699C0.404191 7.13621 0.568347 6.64191 0.972777 6.58096L5.7279 5.86431L7.838 1.4298C8.01892 1.04958 8.56006 1.04958 8.74099 1.4298L10.8511 5.86431L15.6062 6.58096C16.0106 6.64191 16.1748 7.13621 15.8872 7.42699L12.4342 10.9179L13.2455 15.8235C13.3134 16.2345 12.8785 16.5435 12.5128 16.3441L8.28949 14.0412Z",
    fill: "#F59914"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.41fd4662024770541af28ce800758427.svg";
export { ForwardRef as ReactComponent };